import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67e326c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "price" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "tip" }
const _hoisted_5 = {
  key: 0,
  class: "tag"
}

export interface IExpPackageMenuItem {
  exp_package_menu_id: string
  title: string
  origin_price: number
  price: number
  tip: string
  tag: string
  desc: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PurchaseCard',
  props: {
    active: { type: Boolean },
    card: {}
  },
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card", {on:_ctx.active}])
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.card.title), 1),
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode("¥" + _toDisplayString(_ctx.card.price), 1),
      (_ctx.card.origin_price)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "¥" + _toDisplayString(_ctx.card.origin_price), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.card.tip), 1),
    (_ctx.card.tag)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.card.tag), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})